import BarcodeScannerComponent from './BarcodeScannerComponent';
export default BarcodeScannerComponent;
